import { useBreakpoint } from '@hh.ru/magritte-ui';

import { useExperiment } from 'src/hooks/useExperiment';

export const useGeoFiltersRedesignExp = (sendExpCheck = false) => {
    const { isMobile } = useBreakpoint();
    return useExperiment('resume_search_geo_filters', !isMobile, sendExpCheck);
};

export const useGeoFiltersMetroRedesignExp = (sendExpCheck = false) => {
    const { isMobile } = useBreakpoint();
    return useExperiment('resume_search_metro_geo_filter', !isMobile, sendExpCheck);
};
